import angular from 'angular';
import ErrorInterceptorService from './errorInterceptor.service';

let errorInterceptorModule = angular

  .module('app.errorInterceptor', [])

  .service('ErrorInterceptorService', ErrorInterceptorService)

  .factory('errorInterceptorInjector', ($injector, $q, $log) => {
    'ngInject';

    return {
      responseError: (response) => {
        $log.info('errorInterceptorInjector: responseError ' + response.status);
        $log.info('errorInterceptorInjector: response ' + JSON.stringify(response));
        const ErrorInterceptorService = $injector.get('ErrorInterceptorService');
        ErrorInterceptorService.manageError(response);
        return $q.reject(response);
      }
    };
  })

  .config(($httpProvider) => {
    'ngInject';
    $httpProvider.interceptors.push('errorInterceptorInjector');
  })

  .name;

export default errorInterceptorModule;



// WEBPACK FOOTER //
// ./client/app/common/interceptors/errorInterceptor/errorInterceptor.js